import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LanguageTranslationModule} from './shared/modules/language-translation/language-translation.module';
import {ApiService} from './shared/services/api/api.service';
import {AccountService} from './shared/services/account/account.service';
import {AuthenticationManager} from './shared/services/authentication/authenticationManager';
import {CommonService} from './shared/services/common/common.service';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateMomentParserFormatter} from './shared/services/ngbDateFormatter/ngbcustomdateformatter.service';
import {AuthenticationService} from './shared/services/authentication/authentication.service';
import {StorageService} from './shared/services/storage/storage.service';
import {AuthGuard} from './shared';
import {AlertService} from './shared/services/alert/alert.service';
import {EncryptDecryptService} from './shared/services/encryptDecrypt/encryptDecrypt.service';
import {DisableRightClickDirective} from './shared/directive/rightclick.directive';
import { FormsModule } from '@angular/forms';
import { TokenInterceptor } from './shared/services/authentication/token.interceptor';
import { SharedModule } from './shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        LanguageTranslationModule,
        AppRoutingModule,
        NgbModule,
        FormsModule,
        SharedModule
    ],
    declarations: [AppComponent, DisableRightClickDirective],
    providers: [
        AuthGuard,
        ApiService,
        AuthenticationService,
        AccountService,
        AlertService,
        StorageService,
        AuthenticationManager,
        EncryptDecryptService,
        CommonService,
        {
            provide: NgbDateParserFormatter,
            useFactory: () => {
                return new NgbDateMomentParserFormatter('DD/MM/YYYY');
            }
        },
        {
             provide: HTTP_INTERCEPTORS,
             useClass: TokenInterceptor,
             multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
